import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    popupIndicatorOpen: {
      transform: 'none',
    },
    paper: {
      boxShadow: theme.shadows[16],
      background: theme.palette.grey[50],
    },
    paperSearch: {
      background: theme.palette.common.white,
    },
    option: {
      '&[data-focus="true"]': {
        background: theme.palette.grey[300],
      },
    },
    optionSearch: {
      '&[data-focus="true"]': {
        background: theme.palette.grey[100],
      },
    },
    chip: {
      marginLeft: 4,
    },
    autocompleteMultipleRoot: {
      padding: '14px !important',
    },
    listbox: {
      // Without this, tight vertical space makes it unclear
      // there's more than one item, default is 40vh
      '@media (min-height: 190px) and (max-height: 600px)': {
        maxHeight: '60vh',
      },
    },
    nearInputRoot: {
      paddingRight: '6px !important',
    },
  };
});
